// extracted by mini-css-extract-plugin
export default {"site-logo":"SiteLogo_site-logo_Q7yco","is-pure-color":"SiteLogo_is-pure-color_gZxBp","text-e":"SiteLogo_text-e_VXiyV","text-x":"SiteLogo_text-x_PetaT"};